
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as errori9Edg0gghXES6Im9jgtQRuRuDxmZRKhNjxjv_sKe1sIMeta } from "/opt/build/repo/website/core/pages/error.vue?macro=true";
import { default as index5JfrOuoK5Klq1yoOLUpPr93LFp29OwfoeTbtF9O763AMeta } from "/opt/build/repo/website/payment-methods/pages/pricing/index.vue?macro=true";
import { default as indexNUVLN0s9iU30vFpHmaz0QQpCBkAf9RSzZyjWaQuk8cgMeta } from "/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue?macro=true";
import { default as _91slug_93em2fTDzn1bOZuve_0Ixk45AiAz3G45gpiUI4tG5iIzAMeta } from "/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue?macro=true";
import { default as index61dLrrT8lt9x1UArM_bUQuu_N6DrNTFYrRhjDumInlwMeta } from "/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue?macro=true";
import { default as indexCSngEx2GB4HHrRN3nMaZt9PObpbxiP6aMA9r_455BJ_45YsMeta } from "/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue?macro=true";
import { default as indexJ2dZkoW12Ksk4GNBEfISIObMj4IQtN8TtF5eTe5GBSkMeta } from "/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue?macro=true";
import { default as _91country_93SrM50z8sROwYfUwpQkDzmRzj11z259Ena_gjX7XEHUkMeta } from "/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "error___en",
    path: "/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___en_AU",
    path: "/en_AU/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___pt_BR",
    path: "/pt_BR/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___zh_CN",
    path: "/zh_CN/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___cs_CZ",
    path: "/cs_CZ/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___da_DK",
    path: "/da_DK/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___de_DE",
    path: "/de_DE/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___es_ES",
    path: "/es_ES/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___fr_FR",
    path: "/fr_FR/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___it_IT",
    path: "/it_IT/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___ja_JP",
    path: "/ja_JP/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___es_MX",
    path: "/es_MX/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___nl_NL",
    path: "/nl_NL/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___no_NO",
    path: "/no_NO/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___pl_PL",
    path: "/pl_PL/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___pt_PT",
    path: "/pt_PT/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___sv_SE",
    path: "/sv_SE/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___en_AE",
    path: "/en_AE/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___en_SG",
    path: "/en_SG/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___en_GB",
    path: "/en_GB/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "pricing___en",
    path: "/pricing",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___en_AU",
    path: "/en_AU/pricing",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___pt_BR",
    path: "/pt_BR/precos",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___zh_CN",
    path: "/zh_CN/pricing",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___cs_CZ",
    path: "/cs_CZ/pricing",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___da_DK",
    path: "/da_DK/priser",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___de_DE",
    path: "/de_DE/preise",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___es_ES",
    path: "/es_ES/precios",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___fr_FR",
    path: "/fr_FR/tarifs",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___it_IT",
    path: "/it_IT/tariffe",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___ja_JP",
    path: "/ja_JP/pricing",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___es_MX",
    path: "/es_MX/precios",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___nl_NL",
    path: "/nl_NL/tarieven",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___no_NO",
    path: "/no_NO/priser",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___pl_PL",
    path: "/pl_PL/cennik",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___pt_PT",
    path: "/pt_PT/precos",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___sv_SE",
    path: "/sv_SE/prissattning",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___en_AE",
    path: "/en_AE/pricing",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___en_SG",
    path: "/en_SG/pricing",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "pricing___en_GB",
    path: "/en_GB/pricing",
    component: () => import("/opt/build/repo/website/payment-methods/pages/pricing/index.vue")
  },
  {
    name: "payment-methods___en",
    path: "/payment-methods",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___en_AU",
    path: "/en_AU/payment-methods",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___pt_BR",
    path: "/pt_BR/metodos-pagamento",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___zh_CN",
    path: "/zh_CN/payment-methods",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___da_DK",
    path: "/da_DK/betalingsmetoder",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___de_DE",
    path: "/de_DE/zahlungsmethoden",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___es_ES",
    path: "/es_ES/metodos-de-pago",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___fr_FR",
    path: "/fr_FR/moyens-de-paiement",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___it_IT",
    path: "/it_IT/metodi-di-pagamento",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___ja_JP",
    path: "/ja_JP/payment-methods",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___es_MX",
    path: "/es_MX/metodos-de-pago",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___nl_NL",
    path: "/nl_NL/betaalmethoden",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___no_NO",
    path: "/no_NO/betalingsmetoder",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___pl_PL",
    path: "/pl_PL/metody-platnosci",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___pt_PT",
    path: "/pt_PT/metodos-pagamento",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___sv_SE",
    path: "/sv_SE/betalningsmetoder",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___en_AE",
    path: "/en_AE/payment-methods",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___en_SG",
    path: "/en_SG/payment-methods",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods___en_GB",
    path: "/en_GB/payment-methods",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/index.vue")
  },
  {
    name: "payment-methods-slug___en",
    path: "/payment-methods/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___en_AU",
    path: "/en_AU/payment-methods/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___pt_BR",
    path: "/pt_BR/metodos-pagamento/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___zh_CN",
    path: "/zh_CN/payment-methods/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___da_DK",
    path: "/da_DK/betalingsmetoder/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___de_DE",
    path: "/de_DE/zahlungsmethoden/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___es_ES",
    path: "/es_ES/metodos-de-pago/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___fr_FR",
    path: "/fr_FR/moyens-de-paiement/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___it_IT",
    path: "/it_IT/metodi-di-pagamento/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___ja_JP",
    path: "/ja_JP/payment-methods/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___es_MX",
    path: "/es_MX/metodos-de-pago/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___nl_NL",
    path: "/nl_NL/betaalmethoden/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___no_NO",
    path: "/no_NO/betalingsmetoder/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___pl_PL",
    path: "/pl_PL/metody-platnosci/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___pt_PT",
    path: "/pt_PT/metodos-pagamento/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___sv_SE",
    path: "/sv_SE/betalningsmetoder/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___en_AE",
    path: "/en_AE/payment-methods/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___en_SG",
    path: "/en_SG/payment-methods/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-slug___en_GB",
    path: "/en_GB/payment-methods/:slug()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods/[slug].vue")
  },
  {
    name: "payment-methods-guides___en",
    path: "/payment-methods-guides",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___en_AU",
    path: "/en_AU/payment-methods-guides",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___pt_BR",
    path: "/pt_BR/guias-metodos-de-pagamento",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___zh_CN",
    path: "/zh_CN/payment-methods-guides",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___da_DK",
    path: "/da_DK/vejledninger-til-betalingsmetoder",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___de_DE",
    path: "/de_DE/zahlungsmethode-guides",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___es_ES",
    path: "/es_ES/guias-metodos-pago",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___fr_FR",
    path: "/fr_FR/guides-moyens-paiement",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___it_IT",
    path: "/it_IT/guide-metodi-di-pagamento",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___es_MX",
    path: "/es_MX/guias-metodos-pago",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___nl_NL",
    path: "/nl_NL/betaalmethoden-guides",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___no_NO",
    path: "/no_NO/veiledninger-for-betalingsmetoder",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___pl_PL",
    path: "/pl_PL/przewodnik-po-metodach-platnosci",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___pt_PT",
    path: "/pt_PT/guias-metodos-de-pagamento",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___sv_SE",
    path: "/sv_SE/guider-till-betalningsmetoder",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___en_AE",
    path: "/en_AE/payment-methods-guides",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___en_SG",
    path: "/en_SG/payment-methods-guides",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-guides___en_GB",
    path: "/en_GB/payment-methods-guides",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/index.vue")
  },
  {
    name: "payment-methods-glossary___en",
    path: "/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___pt_BR",
    path: "/pt_BR/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___zh_CN",
    path: "/zh_CN/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___da_DK",
    path: "/da_DK/glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___de_DE",
    path: "/de_DE/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___es_ES",
    path: "/es_ES/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___fr_FR",
    path: "/fr_FR/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___it_IT",
    path: "/it_IT/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___ja_JP",
    path: "/ja_JP/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___es_MX",
    path: "/es_MX/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___nl_NL",
    path: "/nl_NL/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___no_NO",
    path: "/no_NO/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___pl_PL",
    path: "/pl_PL/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___pt_PT",
    path: "/pt_PT/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___sv_SE",
    path: "/sv_SE/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___en_SG",
    path: "/en_SG/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-glossary___en_GB",
    path: "/en_GB/payment-methods-glossary",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-glossary/index.vue")
  },
  {
    name: "payment-methods-guides-region___en",
    path: "/payment-methods-guides/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___en_AU",
    path: "/en_AU/payment-methods-guides/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___pt_BR",
    path: "/pt_BR/guias-metodos-de-pagamento/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___zh_CN",
    path: "/zh_CN/payment-methods-guides/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___da_DK",
    path: "/da_DK/vejledninger-til-betalingsmetoder/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___de_DE",
    path: "/de_DE/zahlungsmethode-guides/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___es_ES",
    path: "/es_ES/guias-metodos-pago/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___fr_FR",
    path: "/fr_FR/guides-moyens-paiement/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___it_IT",
    path: "/it_IT/guide-metodi-di-pagamento/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___es_MX",
    path: "/es_MX/guias-metodos-pago/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___nl_NL",
    path: "/nl_NL/betaalmethoden-guides/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___no_NO",
    path: "/no_NO/veiledninger-for-betalingsmetoder/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___pl_PL",
    path: "/pl_PL/przewodnik-po-metodach-platnosci/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___pt_PT",
    path: "/pt_PT/guias-metodos-de-pagamento/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___sv_SE",
    path: "/sv_SE/guider-till-betalningsmetoder/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___en_AE",
    path: "/en_AE/payment-methods-guides/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___en_SG",
    path: "/en_SG/payment-methods-guides/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region___en_GB",
    path: "/en_GB/payment-methods-guides/:region()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/index.vue")
  },
  {
    name: "payment-methods-guides-region-country___en",
    path: "/payment-methods-guides/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___en_AU",
    path: "/en_AU/payment-methods-guides/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___pt_BR",
    path: "/pt_BR/guias-metodos-de-pagamento/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___zh_CN",
    path: "/zh_CN/payment-methods-guides/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___da_DK",
    path: "/da_DK/vejledninger-til-betalingsmetoder/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___de_DE",
    path: "/de_DE/zahlungsmethode-guides/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___es_ES",
    path: "/es_ES/guias-metodos-pago/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___fr_FR",
    path: "/fr_FR/guides-moyens-paiement/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___it_IT",
    path: "/it_IT/guide-metodi-di-pagamento/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___es_MX",
    path: "/es_MX/guias-metodos-pago/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___nl_NL",
    path: "/nl_NL/betaalmethoden-guides/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___no_NO",
    path: "/no_NO/veiledninger-for-betalingsmetoder/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___pl_PL",
    path: "/pl_PL/przewodnik-po-metodach-platnosci/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___pt_PT",
    path: "/pt_PT/guias-metodos-de-pagamento/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___sv_SE",
    path: "/sv_SE/guider-till-betalningsmetoder/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___en_AE",
    path: "/en_AE/payment-methods-guides/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___en_SG",
    path: "/en_SG/payment-methods-guides/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: "payment-methods-guides-region-country___en_GB",
    path: "/en_GB/payment-methods-guides/:region()/:country()",
    component: () => import("/opt/build/repo/website/payment-methods/pages/payment-methods-guides/[region]/[country].vue")
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/en_AU/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/pt_BR/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/zh_CN/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/cs_CZ/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/da_DK/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/de_DE/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/es_ES/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/fr_FR/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/it_IT/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/ja_JP/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/es_MX/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/nl_NL/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/no_NO/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/pl_PL/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/pt_PT/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/sv_SE/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/en_AE/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/en_SG/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  },
  {
    name: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0sMeta?.name,
    path: "/en_GB/sitemap.xml",
    component: component_45stubE86B9032rcV2J_cDe4Vtg3adsHBytwsL_y2ub6Qyo0s
  }
]